// extracted by mini-css-extract-plugin
module.exports = {"title":"LandlordReviews_title___Ae6F","reviewsContainer":"LandlordReviews_reviewsContainer__yrWc_"};